export const CurrentUserQueryKeys = {
  all: ["query", "current-user"] as const,
  getCurrentUser: () => [...CurrentUserQueryKeys.all, "get"] as const,
};
